// Subset of lumika-app/packages/shared/src/types/realtime.ts.
// Kept local to the playground (a self-contained dev/test tool) to avoid
// coupling it to the wider shared realtime types.

export interface AgentStartEvent {
  type: "agent_start";
  sessionId: string;
  channel?: { id: string; type: string; name: string };
}

export interface TurnStartEvent {
  type: "turn_start";
  leadId: string;
  messageId?: string;
}

export interface MessageStartEvent {
  type: "message_start";
  leadId: string;
  messageId: string;
  role: "user" | "assistant";
}

export interface MessageUpdateEvent {
  type: "message_update";
  leadId: string;
  messageId: string;
  delta: string;
}

export interface MessageEndEvent {
  type: "message_end";
  leadId: string;
  messageId: string;
  role: "user" | "assistant";
  text: string;
}

export interface TurnEndEvent {
  type: "turn_end";
  leadId: string;
}

export interface AgentEndEvent {
  type: "agent_end";
  sessionId?: string;
}

export interface ErrorEvent {
  type: "error";
  code?: number | string;
  message: string;
}

export type ClientToolEventType =
  | "search_vehicles"
  | "search_facets"
  | "get_vehicle"
  | "rooftop_context"
  | "create_cards"
  | "brave_search"
  | "submit_contact"
  | "submit_vehicle"
  | "submit_tradein"
  | "submit_appointment"
  | "internal_tool";

export interface ClientToolEvent {
  type: ClientToolEventType;
  leadId: string;
  messageId: string;
  label: string;
  payload: unknown;
}

export type RealtimeEvent =
  | AgentStartEvent
  | TurnStartEvent
  | MessageStartEvent
  | MessageUpdateEvent
  | MessageEndEvent
  | TurnEndEvent
  | AgentEndEvent
  | ErrorEvent
  | ClientToolEvent;

export const TOOL_EVENT_TYPES: ReadonlySet<string> = new Set([
  "search_vehicles",
  "search_facets",
  "get_vehicle",
  "rooftop_context",
  "create_cards",
  "brave_search",
  "submit_contact",
  "submit_vehicle",
  "submit_tradein",
  "submit_appointment",
  "internal_tool",
]);
